<template>
  <div class="login-page register-page">
    <div id="">
      <div class="login-page" :class="{ minHeight: store.showOTP }">
        <div class="register-holder center-div wow fadeIn">
          <router-link to="/login">
            <img width="145" src="assets/images/logo.svg" alt="" />
          </router-link>
          <br /><br />
          <div class="form-holder">
            <div class="form-group" v-if="store.showOTP">
              <h4>{{$t('auth.sent_an_OTP')}} {{ form.email }}. {{$t('auth.complete_your_registration')}}</h4>
              <Form @submit="verify">
                <ul class="clearfix">
                  <li class="">
                    <label for="">{{$t('auth.otp')}} <span style="color: #d43737">*</span></label>
                    <Field
                      class="form-control"
                      name="otp"
                      rules="required|numeric|min:6|max:6"
                      v-model="otp"
                    />
                    <ErrorMessage name="otp" />
                  </li>
                </ul>
                <div class="btn-holder t-center">
                  <button class="btn btn-blue popup-link-holder">{{$t('auth.submit')}}</button>
                </div>
              </Form>
            </div>
            <Form v-else @submit="register">
              <h3 class="t-center">{{$t('auth.Register_heading')}}</h3>
              <ul class="clearfix">
                <!-- <li class="full-width f-left noColor">
                  <label for="">Account Type</label>
                  <Field
                    class="form-control"
                    name="account type"
                    v-model="form.account_type"
                    rules="required"
                    as="select"
                  >
                    <option value="" disabled>Select account type</option>
                    <option
                      v-for="type in static_vars.registrationType"
                      :value="type.value"
                      :key="type.value"
                    >
                      {{ type.label }}
                    </option>
                  </Field>
                  <ErrorMessage name="account type" />
                </li> -->
                <!-- <li class="full-width f-left noColor">
                  <label for="">Account Type</label>
                  <Field
                    class="form-control"
                    name="Account type"
                    v-model="form.account_type"
                    rules="required"
                    as="select"
                    @change="accountType"
                  >
                    <option value="" disabled>Select Account Type</option>
                    <option value="1">Individual</option>
                    <option value="2">Corporate</option>
                  </Field>
                  <ErrorMessage name="Account type" />
                </li> -->
                <li class="full-width f-left">
                  <label for="">{{$t('auth.first_name')}}</label>
                  <Field
                    class="form-control"
                    name="first name"
                    autofill="off"
                    autocomplete="username"
                    v-model="form.firstname"
                    rules="required"
                  />
                  <ErrorMessage name="first name" />
                </li>
                <li class="full-width f-left">
                  <label for="">{{$t('auth.last_name')}}</label>
                  <Field
                    class="form-control"
                    name="last name"
                    autofill="off"
                    autocomplete="username"
                    v-model="form.lastname"
                    rules="required"
                  />
                  <ErrorMessage name="last name" />
                </li>
                <li class="full-width f-left">
                  <label for="">{{$t('auth.email')}}</label>
                  <Field
                    class="form-control"
                    name="email"
                    autofill="off"
                    autocomplete="username"
                    v-model="form.email"
                    rules="required|email"
                  />
                  <ErrorMessage name="email" />
                </li>
                <li class="full-width f-left position-relative">
                  <label for="">{{$t('auth.Password')}}</label>
                  <div style="position: relative">
                    <Field
                      :type="inputtype"
                      class="form-control"
                      autofill="off"
                      autocomplete="new-password"
                      name="password"
                      v-model="form.password"
                      rules="required|min:8"
                      @focusin="showPassDiv = true"
                      @focusout="showPassDiv = false"
                    />
                    <vue-feather
                      :type="iconType"
                      class="toggle-password"
                      @click.prevent="switchVisibility"
                    ></vue-feather>
                  </div>
                  <ErrorMessage name="password" />

                  <div id="pr-box" class="light" v-show="showPassDiv">
                    <i></i>
                    <div id="pr-box-inner">
                      <p>{{$t('auth.min_password_length8')}}</p>
                      <ul>
                        <li class="pr-numcharacters">
                          <span
                            :class="form.password.length >= 8 ? 'pr-ok' : ''"
                          ></span
                          >{{$t('auth.spcl_characters')}}
                        </li>
                        <li class="pr-useLowercase">
                          <span :class="lowercaseOK ? 'pr-ok' : ''"></span
                          >{{$t('auth.lowercase_letter')}}
                        </li>
                        <li class="pr-useUppercase">
                          <span :class="uppercaseOk ? 'pr-ok' : ''"></span
                          >{{$t('auth.capital_letter')}}
                        </li>
                        <li class="pr-useNumbers">
                          <span :class="numberOk ? 'pr-ok' : ''"></span>{{$t('auth.number')}}
                        </li>
                        <li class="pr-useSpecial">
                          <span :class="SpecialCharOk ? 'pr-ok' : ''"></span
                          >{{$t('auth.special_character')}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="full-width f-left">
                  <label for="">{{$t('auth.confirm_password')}}</label>
                  <div style="position: relative">
                    <Field
                      :type="inputtype1"
                      class="form-control"
                      name="confirm password"
                      autocomplete="new-password"
                      v-model="form.confirmpassword"
                      rules="required|confirmed:@password"
                    />
                    <vue-feather
                      :type="iconType1"
                      class="toggle-password"
                      @click.prevent="switchVisibility1"
                    ></vue-feather>
                  </div>
                  <ErrorMessage name="confirm password" />
                </li>
                <li class="full-width f-left noColor">
                  <label for="">{{$t('auth.country')}}</label>
                  <Field
                    class="form-control"
                    name="country"
                    v-model="form.residence_country"
                    rules="required"
                    as="select"
                    @change="changecountry"
                  >
                    <option value="" disabled>{{$t('auth.select_residence_country')}}</option>
                    <option
                      v-for="country in store.countries"
                      :value="country.iso2"
                      :key="country.iso2"
                    >
                      {{ country.name }}
                    </option>
                  </Field>
                  <ErrorMessage name="country" />
                </li>
                <li
                  class="full-width f-left"
                  v-show="
                    form.residence_country == '' ||
                    !EUContries.includes(form.residence_country)
                  "
                >
                  <label for="">{{$t('auth.Phone_Number')}}</label>
                  <Field
                    v-slot="{ field }"
                    name="Phone Number"
                    rules="required"
                    v-model="form.mobile"
                  >
                    <vue-tel-input
                      v-bind="field"
                      v-model="form.mobile"
                      @change="onInput"
                      @country-changed="GetCode"
                      ref="phone"
                    ></vue-tel-input>
                    <!-- <Field
                    class="form-control"
                    name="phone"
                    v-model="form.phone"
                    rules="required|numeric"
                  /> -->
                  </Field>
                  <ErrorMessage name="Phone Number" />
                </li>
                <li style="padding-bottom: 1px;"
                  class="full-width f-left"
                  v-show="
                    form.residence_country == '' ||
                    !EUContries.includes(form.residence_country)
                  "
                >
                  <div class="d-flex align-items-center">
                  <div class="checkbox checkbox2 " style="width: fit-content;">
                    <input
                      type="checkbox"
                      v-model="form.acceptterms"
                      :true-value="true"
                      :false-value="false"
                    />
                    <span></span>
                   <p>{{$t('auth.have_read')}}</p>
                  </div>
                  <p class="mb-0"><a class="m-0" style="margin: 3px 0px 0; color: #1b9ad4;" href="assets/pdf/Retail_Client_Agreement_v1.pdf" target="_blank">{{$t('auth.terms_conditions')}}</a></p>
                </div>
                  <span style="color: #ff0000; font-size: 14px" v-if="submitted && !form.acceptterms">{{$t('auth.accept_terms_conditions')}}</span>
                </li>

                <li
                  class="full-width f-left"
                  v-show="
                    form.residence_country == '' ||
                    !EUContries.includes(form.residence_country)
                  "
                >
                  <div class="d-flex align-items-center">
                  <div class="checkbox checkbox2 " style="width: fit-content;">
                    <input
                      type="checkbox"
                      v-model="form.acceptprivacy"
                      :true-value="true"
                      :false-value="false"
                    />
                    <span></span>
                   <p>{{$t('auth.have_read')}}</p>
                  </div>
                  <p class="mb-0"><a class="m-0" style="margin: 3px 0px 0; color: #1b9ad4;" href="assets/pdf/Privacy-Policy_V1.pdf" target="_blank">{{$t('auth.privacy_policy')}}</a></p>
                </div>
                  <span style="color: #ff0000; font-size: 14px" v-if="submitted && !form.acceptprivacy">{{$t('auth.accept_privacy_policy')}}</span>
                </li>
              </ul>
              <div
                class="errormsg"
                v-show="
                  form.residence_country != '' &&
                  EUContries.includes(form.residence_country)
                "
              >
                <p style="color: red">{{$t('auth.experts_investment_services')}}<a href="#">{{$t('auth.continue')}} </a>{{$t('auth.opening_your_account')}}
                </p>
              </div>
              <!-- {{this.residence_country}} -->
              <div
                class="btn-holder"
                v-show="
                  form.residence_country == '' ||
                  !EUContries.includes(form.residence_country)
                "
              >
                <button type="submit" class="btn btn-yellow popup-link-holder">
                  {{$t('auth.register')}}
                </button>
              </div>
            </Form>
          </div>
          
          <!-- {{this.static_vars.european_countries_list}} -->
          <div class="links">
            <p>{{$t('auth.already_have_account')}}<router-link to="/login">{{$t('auth.login')}}</router-link>
            </p>
          </div>
        </div>
      </div>
      <!-- Country base popup -->
      <!-- <div v-if="porPopup || form.residence_country != '' && form.residence_country != null && form.residence_country != undefined && !this.static_vars.european_countries_list.hasOwnProperty(form.residence_country)">
        <div class="mfp-bg animated zoomIn mfp-ready"></div>
        <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
          <div class="mfp-container mfp-s-ready mfp-inline-holder">
            <div class="mfp-content">
              <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                <div class="content t-white t-left"
                  <p class="text-center" style="font-size: 14px;">
                    {{$t('auth.chEn_redirectmsg1')}}
                    {{$t('auth.chEn_redirectmsg2')}}
                  </p>
                </div>
                <div class="d-flex justify-content-center">
                  <a href="https://my.aaafx.com/register"  class="btn btn-yellow popup-link-holder mr-3">{{$t('auth.chEn_continue')}}</a>
                  <a href="#" @click="form.residence_country = ''" class="btn btn-yellow popup-link-holder">{{$t('auth.chEn_takeback')}}</a>
                </div>
                <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="porPopup = false">×</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  mounted() {
    this.store.getCountriesList();
    this.EUContries = Object.keys(this.static_vars.european_countries_list).map(
      (val) => val
    );
    setTimeout(() => {
      let _that = this
      let ip_country = localStorage.getItem("ip_country") || '';
      if(ip_country){
        this.callCriteo(ip_country);
      }else{
        try{
          /*fetch('https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs').then(res => {*/
          fetch('https://api.aaafx.com/get/geo').then(res => {
            if (res.ok) { return res.text(); }
            else { throw new Error('HTTP Error ' + res.status); }
          })
          .then(country => {
            _that.callCriteo(country);
          }).catch(function(error) { console.log(error);  });
        }catch(error){ console.log(error); }
      }
    }, "3000");
  },
  data() {
    return {
      porPopup: false,
      otp: "",
      form: {
        email: "",
        password: "",
        confirmpassword: "",
        residence_country: "",
        phone: "",
        acceptterms: false,
        acceptprivacy: false,
        rm_id: "0",
        IBREFERLINK: "",
        account_type: "",
        admin_id: "0",
        captchaToken: "",
        ip_country: "IN",
        firstname : "",
        lastname : "",
      },
      submitted: false,
      showpassword: false,
      iconType: "eye-off",
      inputtype: "password",
      showpassword1: false,
      iconType1: "eye-off",
      inputtype1: "password",
      showPassDiv: false,
      lowercaseOK: false,
      uppercaseOk: false,
      numberOk: false,
      SpecialCharOk: false,
      phoneCode: "",
      phoneNo: "",
      EUContries: [],
    };
  },
  watch: {
    "form.password": function (val) {
      let lowerCase = new RegExp("[a-z]"),
        upperCase = new RegExp("[A-Z]"),
        numbers = new RegExp("[0-9]"),
        specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~]");
      if (val.match(lowerCase)) {
        this.lowercaseOK = true;
      } else {
        this.lowercaseOK = false;
      }
      if (val.match(upperCase)) {
        this.uppercaseOk = true;
      } else {
        this.uppercaseOk = false;
      }
      if (val.match(numbers)) {
        this.numberOk = true;
      } else {
        this.numberOk = false;
      }
      if (val.match(specialcharacter)) {
        this.SpecialCharOk = true;
      } else {
        this.SpecialCharOk = false;
      }
      if (
        this.lowercaseOK &&
        this.uppercaseOk &&
        this.numberOk &&
        this.SpecialCharOk &&
        val.length >= 8
      ) {
        this.showPassDiv = false;
      }
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    callCriteo(country){
      let p_countries = {'AE':104591,'DE':104621,'DK':104622,'ES':104623,'ID':104624,'IT':103069,'KE':104625,'MA':104626,'MY':104627,'NG':104628,'NL':104629,'PH':104630,'PL':103068,'PT':104631,'SA':104632,'SE':104633,'SG':104634,'TH':104635,'ZA':104636};
      this.form.ip_country = country;
      if(p_countries[country]){
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        try{
            let setAccount = { event: "setAccount", account: p_countries[country] };
            let setEmail = { event: "setEmail", email: "" };
            let setSiteType = { event: "setSiteType", type: deviceType};
            let viewBasket = { event: "viewBasket", item: [
                {id: "registration", price: "1", quantity: "1" }
            ]};
            window.criteo_q.push(setAccount,setEmail,setSiteType,viewBasket);
        }catch(e){ console.log(e); }
      }
    },
    accountType(e) {
      this.account_type = e.target.value;
      if(this.account_type == "2") {
        this.$router.push('/corporate')
      }
    },
    changecountry(e) {
      this.$refs.phone.choose(e.target.value);
    },
    onInput(e) {
      this.phoneNo = e.target.value;
    },
    GetCode(e) {
      this.phoneCode = e.dialCode;
    },
    register() {
      this.submitted = true;
      this.account_type = "";
      this.form.phone = `${this.phoneCode} ${this.phoneNo}`;
      if (this.form.acceptterms && this.form.acceptprivacy) {
        this.submitted = false;

        //===========in use==============
        if (this.$cookies.get("investing_ref")) {
          this.form.investing_ref = this.$cookies.get("investing_ref");
        }
        if(this.$cookies.get('refLink') && this.$cookies.get('refRm')){
            this.form.rm_id = this.$cookies.get('refRm')
            this.form.admin_id = this.$cookies.get('refLink')
        }else if(this.$cookies.get('IBREFERLINK')){
            let decrpyLinRm = window.atob(this.$cookies.get('IBREFERLINK').toString()) ; 
            let decrpyLinRm1 = decrpyLinRm.split('||')
            this.$cookies.set("refLink",window.btoa(decrpyLinRm1[0]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
            this.$cookies.set("refRm",window.btoa(decrpyLinRm1[1]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
            this.form.rm_id = this.$cookies.get('refRm')
            this.form.admin_id = this.$cookies.get('refLink')
        }
        this.store.register(this.form, true);
      } else {
        return;
      }
    },
    switchVisibility() {
      this.showpassword = !this.showpassword;
      if (this.showpassword) {
        this.inputtype = "text";
        this.iconType = "eye";
      } else {
        this.inputtype = "password";
        this.iconType = "eye-off";
      }
    },
    switchVisibility1() {
      this.showpassword1 = !this.showpassword1;
      if (this.showpassword1) {
        this.inputtype1 = "text";
        this.iconType1 = "eye";
      } else {
        this.inputtype1 = "password";
        this.iconType1 = "eye-off";
      }
    },
    verify() {
      let formData = {
        otp: this.otp,
        ID: this.store.trans_id,
        email: this.form.email,
        password: this.form.password,
      };
      //===========in use==============
      if (this.$cookies.get("investing_ref")) {
        formData.investing_ref = this.$cookies.get("investing_ref");
      }
      if(this.$cookies.get('refLink') && this.$cookies.get('refRm')){
          formData.rm_id = this.$cookies.get('refRm')
          formData.admin_id = this.$cookies.get('refLink')
      }else if(this.$cookies.get('IBREFERLINK')){
          let decrpyLinRm = window.atob(this.$cookies.get('IBREFERLINK').toString()) ; 
          let decrpyLinRm1 = decrpyLinRm.split('||')
          this.$cookies.set("refLink",window.btoa(decrpyLinRm1[0]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
          this.$cookies.set("refRm",window.btoa(decrpyLinRm1[1]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
          formData.rm_id = this.$cookies.get('refRm')
          formData.admin_id = this.$cookies.get('refLink')
      }
      this.store.verifyRegistration(formData, true);
    },
    selectCountry(e) {
      this.form.residence_country = e.iso2;
    },
  },
  created(){
    if(this.form.residence_country === "") {
      console.log(this.form.residence_country, "country==>")
    }
       //=============in use===================
       //console.log("svae link", process.env.VUE_APP_cookieSaveUrl)
      if(this.$route.query.investing_ref){
        this.$cookies.set( "investing_ref", this.$route.query.investing_ref, "1y", null, process.env.VUE_APP_cookieSaveUr );
      }
      if(this.$route.query.refLink && this.$route.query.refRm){
          this.$cookies.set("refLink",this.$route.query.refLink,"4y", null, process.env.VUE_APP_cookieSaveUrl);
          this.$cookies.set("refRm",this.$route.query.refRm,"4y", null, process.env.VUE_APP_cookieSaveUrl);
          this.$router.replace({query: null})
      }else if(this.$cookies.get('IBREFERLINK')){
          let decrpyLinRm = window.atob(this.$cookies.get('IBREFERLINK').toString()) ; 
          let decrpyLinRm1 = decrpyLinRm.split('||')
          this.$cookies.set("refLink",window.btoa(decrpyLinRm1[0]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
          this.$cookies.set("refRm",window.btoa(decrpyLinRm1[1]),"4y", null, process.env.VUE_APP_cookieSaveUrl);
      }else{
        this.$router.replace({query: null})
      }
  },
};
</script>
<style scoped>
:deep() .vs__selected-options {
  flex-wrap: nowrap !important;
}
:deep() .form-holder ul li.noColor input.vs__search {
  border-color: transparent;
}
:deep() .vs__dropdown-toggle {
  border: 1px solid #28485e;
}
.minHeight {
  min-height: 100vh;
}
</style>
